import { takeLatest, put, select, call, take, delay, race } from 'redux-saga/effects';
import {
    GET_HISTORY_ACCESS_GPS_REQUEST,
    getHistoryAccessGpsSuccess,
    getHistoryAccessGpsFailure,
} from '../actions/history';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { getHistoryAccessGps } from '../services/historyLogs';

let continueWhileWebsocket = true;

const getHistoryAccessGpsWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
       

        const response = yield call(getHistoryAccessGps, filters, token);

        const {
            data: { history, total } 
        } = response;

        yield put(getHistoryAccessGpsSuccess(history, total));
    } catch (err) {
        yield put(getHistoryAccessGpsFailure(err));
        yield put(showGlobalError(true, err));
    }
};


export default [
    takeLatest(GET_HISTORY_ACCESS_GPS_REQUEST, getHistoryAccessGpsWorker),
];
